
function Header() {
  return (
    <div className='pl-20 bg-btn-hover block p-2 pb-4 text-white'>
        <h1 className="text-4xl font-semibold mb-2">Todo App</h1>
        <p className="text-xs">&copy; Dennis Kim 2022</p>
    </div>
  )
}

export default Header;